module.exports = __webpack_public_path__ + "static/media/LEGACY_LEG-G4SPREM_01.4bdb5bb2.xlsx";